"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioCardGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const input_styles_1 = require("@/components/common/input/input.styles");
const single_selection_controller_1 = require("@/controllers/single-selection-controller");
const slotted_selection_controller_1 = require("@/controllers/slotted-selection-controller");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
/**
 * 카드는 가격·배지·설명처럼 옵션 배열로 표현할 수 없는 콘텐츠를 담으므로,
 * mm-radio-group과 달리 mm-radio-card를 자식으로 받아 선택 상태를 소유한다.
 */
let RadioCardGroup = class RadioCardGroup extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.value = '';
        this.name = '';
        this.disabled = false;
        this.legend = '';
        this.selection = new single_selection_controller_1.SingleSelectionController({
            getValue: () => this.value,
            setValue: value => {
                this.value = value;
            },
        });
        this.group = new slotted_selection_controller_1.SlottedSelectionController(this, {
            selection: this.selection,
            getItems: () => this.cards,
            applyItem: card => {
                if (this.name)
                    card.name = this.name;
                // 그룹 disabled는 항목 자신의 disabled를 덮지 않고 더한다.
                // disabled는 reflect하지 않으므로 attribute가 마크업이 선언한 의도로 남는다.
                card.disabled = this.disabled || card.hasAttribute('disabled');
            },
            onChange: () => {
                (0, utils_1.emit)(this, 'change', { value: this.value, name: this.name });
            },
        });
    }
    render() {
        return (0, lit_1.html) `
      <fieldset ?disabled=${this.disabled} @change=${this.group.handleItemChange}>
        <legend>${this.legend}</legend>
        <slot @slotchange=${this.group.handleSlotChange}></slot>
      </fieldset>
    `;
    }
};
RadioCardGroup.styles = [shared_styles_1.resetStyles, input_styles_1.inputSelectionGroupStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], RadioCardGroup.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], RadioCardGroup.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], RadioCardGroup.prototype, "disabled", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], RadioCardGroup.prototype, "legend", void 0);
__decorate([
    (0, decorators_js_1.queryAssignedElements)({ selector: 'mm-radio-card' })
], RadioCardGroup.prototype, "cards", void 0);
RadioCardGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-radio-card-group')
], RadioCardGroup);
exports.RadioCardGroup = RadioCardGroup;
//# sourceMappingURL=data:application/json;base64,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